import { render, staticRenderFns } from "./StirstandIndex.vue?vue&type=template&id=36542dd4&scoped=true&"
import script from "./StirstandIndex.vue?vue&type=script&lang=js&"
export * from "./StirstandIndex.vue?vue&type=script&lang=js&"
import style0 from "./StirstandIndex.vue?vue&type=style&index=0&id=36542dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36542dd4",
  null
  
)

export default component.exports